import React, { useContext, useState } from 'react';
import { Button, Typography, TextField, Stack, RadioGroup, Radio, FormControlLabel, FormControl, Checkbox, FormGroup } from '@mui/material';
import { CinchDialog } from '@cinch/ui';
import { UserStateContext } from 'context/user-state-context';
import { useEffect } from 'react';
import { Label } from '@mui/icons-material';
export const MultiCompanyPrompt = ({
  open,
  onClose,
  onSubmit,
  title,
  permission
}) => {
  const {
    user
  } = useContext(UserStateContext);
  const [option, setOption] = useState('self');
  const [companies, setCompanies] = useState([]);
  const [search, setSearch] = useState('');
  const [availableCompanies, setAvailableCompanies] = useState([]);
  const [showMoreCompanies, setShowMoreCompanies] = useState(10);
  const toggleAll = () => {
    setShowMoreCompanies(availableCompanies.length);
    setCompanies(companies => {
      if (availableCompanies.filter(c => search === '' || c.name.toLowerCase().includes(search.toLowerCase())).every(c => companies.indexOf(c.id) > -1)) {
        return [];
      }
      return availableCompanies.filter(c => search === '' || c.name.toLowerCase().includes(search.toLowerCase())).map(c => c.id);
    });
  };
  const toggleCompany = companyId => {
    setCompanies(companies => {
      if (companies.indexOf(companyId) > -1) {
        return companies.filter(c => c !== companyId);
      }
      return [...companies, companyId];
    });
  };
  useEffect(() => {
    if (!user?.permissions) return;
    setAvailableCompanies(user.companies.sort((a, b) => a.name > b.name ? 1 : -1).filter(function (c) {
      const found = user.permissions['*'] || user.permissions[permission] === '*' || user.permissions?.[permission]?.indexOf(c.id) > -1;
      return found;
    }));
  }, [user]);
  return <CinchDialog open={open} onClose={onClose} title={title} actionSize="large" customWidth={{
    xs: 'calc(100vw - 24px)',
    sm: '460px'
  }} customHeight="auto" onSubmit={() => onSubmit(option === 'self' ? undefined : companies)} submitText="Duplicate" submitDisabled={option !== 'self' && companies.length === 0} bodyData={<Stack direction="column">
          <FormControl>
            <RadioGroup value={option} onChange={e => setOption(e.target.value)}>
              <FormControlLabel value="self" control={<Radio />} label="Copy to this company" />
              <FormControlLabel value="other" control={<Radio />} label="Copy to other companies" />
            </RadioGroup>
          </FormControl>
          {option !== 'self' && <>
              <TextField label="Search companies" value={search} onChange={e => setSearch(e.target.value)} sx={{
        marginBottom: '5px'
      }} />
              <FormGroup>
                <FormControlLabel onChange={toggleAll} value="self" control={<Checkbox checked={availableCompanies.filter(c => search === '' || c.name.toLowerCase().includes(search.toLowerCase())).every(c => companies.indexOf(c.id) > -1) && availableCompanies.filter(c => search === '' || c.name.toLowerCase().includes(search.toLowerCase())).map(c => c.id).length === companies.length} />} label={search == '' ? 'Select all' : 'Select ONLY these filtered companies'} />
                {availableCompanies.filter((comp, index) => index < showMoreCompanies || search != '').filter(c => search === '' || c.name.toLowerCase().includes(search.toLowerCase())).map(c => <FormControlLabel onChange={() => toggleCompany(c.id)} value={c.id} key={c.id} control={<Checkbox checked={companies.indexOf(c.id) > -1} />} label={<Typography sx={{
          maxWidth: '400px'
        }}>{c.name}</Typography>} />)}
              </FormGroup>
              {showMoreCompanies < availableCompanies.length && search == '' && <Button // click this button to show more companies in increments of 20
      onClick={() => setShowMoreCompanies(showMoreCompanies + 20)} variant="text" sx={{
        mr: 1,
        borderRadius: '20px',
        width: '100px',
        color: '#53A6D6',
        textTransform: 'none'
      }}>
                  Show more
                </Button>}
            </>}
        </Stack>} />;
};